import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import FAQSection from './components/FAQSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <MediaSection />
        <ContactSection />
        <FeaturesSection />
        <UpdatesSection />
        <IndexSection />
        <RankingSection />
        <FAQSection />
        <CarouselSection />
        <CommentsSection />
        <TopicsSection />
        <CardsSection />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}